import React from 'react';
import { SchematicShell } from './SchematicPrimitives';
import { DORM_BOARD_FRAME_THICK } from '../../3d/geometry/proceduralRenderers/proceduralSpecs';

/**
 * Corkboard / whiteboard / poster / tapestry elevations.
 *
 * All four are the same object in 3D — `buildBoard` (dormBoardRenderers.js)
 * draws an outer frame with the printed surface inset by `frameThick` on
 * every side. This is the 2D half of that pair, so the inset comes from the
 * SAME `DORM_BOARD_FRAME_THICK` table the renderers read; see
 * web-app/CLAUDE.md, "Procedural objects are drawn TWICE".
 *
 * A tapestry is frameless (cloth hangs bare), so it draws the outline only —
 * matching buildBoard's `frameThick: 0` branch, which emits no frame meshes.
 */
function BoardSchematic({
  widthMeters: width,
  heightMeters: height,
  frameThick,
  strokeColor,
  strokeWidth,
}) {
  // Guard tiny objects: a frame thicker than half the object would invert the
  // inner rect. Never applies at catalog sizes; cheap insurance if resized.
  const inset = Math.min(frameThick, width / 2, height / 2);
  const innerW = width - inset * 2;
  const innerH = height - inset * 2;

  return (
    <SchematicShell
      width={width}
      height={height}
      strokeColor={strokeColor}
      strokeWidth={strokeWidth}
    >
      {inset > 0 && innerW > 0 && innerH > 0 && (
        <rect
          x={inset}
          y={inset}
          width={innerW}
          height={innerH}
          fill="none"
          stroke={strokeColor}
          strokeWidth={strokeWidth}
          vectorEffect="non-scaling-stroke"
        />
      )}
    </SchematicShell>
  );
}

export function DormCorkboardSchematic(props) {
  return (
    <BoardSchematic {...props} frameThick={DORM_BOARD_FRAME_THICK.board} />
  );
}

export function DormWhiteboardSchematic(props) {
  return (
    <BoardSchematic {...props} frameThick={DORM_BOARD_FRAME_THICK.board} />
  );
}

export function DormPosterSchematic(props) {
  return (
    <BoardSchematic {...props} frameThick={DORM_BOARD_FRAME_THICK.poster} />
  );
}

export function DormTapestrySchematic(props) {
  return (
    <BoardSchematic {...props} frameThick={DORM_BOARD_FRAME_THICK.tapestry} />
  );
}
